import { Checkbox, Div, Flex, Gutter, Title } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';
import styles from '../DeviceLimit/DeviceLimit.module.scss';

interface DeviceLimitProps {
  limitToOneDevice: boolean;
  setLimitToOneDevice: (limitToOneDevice: boolean) => void;
}

export default function DeviceLimit(props: DeviceLimitProps) {
  const { limitToOneDevice, setLimitToOneDevice } = props;

  const { t } = useTranslation('organizationForm');

  return (
    <Div padding={{ size: 'lg' }} boxShadow="md">
      <Title size={'sm'}>{t('device_limit.device_limit')}</Title>
      <Flex directionColumn className={styles['customer-organization-form__device-limit-inputs-container']}>
        <Gutter size="layout-5" />
        <Checkbox label={t('device_limit.limit_to_one_device')} checked={limitToOneDevice} onChange={() => setLimitToOneDevice(!limitToOneDevice)} />
        <Gutter size="layout-5" />
      </Flex>
    </Div>
  );
}
